import {HexColorPicker} from "react-colorful";
import {jsx} from "@emotion/react";
import {TextField} from "../../common";
import {Grid, Typography} from "@mui/material";
import {useEffect, useMemo, useState} from "react";

interface ColorPickerProps {
  value: string;
  setValue: any; // todo
  label?: string;
}

interface RGB {
  r: number;
  g: number;
  b: number;
}

export default function ColorPicker({value, setValue, label}: ColorPickerProps) {
  function hexToRgb(hex: string): RGB {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }

    if (hex.length !== 6) {
      return {r: 0, g: 0, b: 0};
    }

    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16),
    };
  }

  function rgbToHex(rgb: RGB) {
    let {r, g, b} = rgb;
    if ([r, g, b].some(v => v < 0 || v > 255 || isNaN(v))) {
      return '#FFFFFF';
    }

    // Convert each value to a 2-digit hex string and concatenate
    const toHex = (val: number) => val.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  const rgb = useMemo(() => hexToRgb(value), [value]);

  return (
    <>
      {label && (
        <Typography variant="subtitle2">
          {label}
        </Typography>
      )}
      <HexColorPicker
        color={value}
        onChange={setValue}
      />
      <Grid container spacing={1} sx={{marginTop: '10px'}}>
        <Grid item xs={4}>
          <TextField
            label={"R"}
            value={rgb.r.toString()}
            onChange={(evt: any) => {
              rgb.r = parseInt(evt.target.value);

              if (rgb.r > 255) {
                rgb.r = 255;
              }
              if (rgb.r < 0) {
                rgb.r = 0;
              }

              setValue(rgbToHex(rgb));
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label={"G"}
            value={rgb.g.toString()}
            onChange={(evt: any) => {
              rgb.g = parseInt(evt.target.value);

              if (rgb.g > 255) {
                rgb.g = 255;
              }
              if (rgb.g < 0) {
                rgb.g = 0;
              }

              setValue(rgbToHex(rgb));
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label={"B"}
            value={rgb.b.toString()}
            onChange={(evt: any) => {
              rgb.b = parseInt(evt.target.value);

              if (rgb.b > 255) {
                rgb.b = 255;
              }
              if (rgb.b < 0) {
                rgb.b = 0;
              }

              setValue(rgbToHex(rgb));
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}